import React, { createContext, useContext, useState } from 'react';
import en from '../locales/en';
import sw from '../locales/sw';

const translations = { en, sw };

const LanguageContext = createContext({
  language: 'en',
  t: en,
  setLanguage: () => {}
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('faida-language');
    return saved && translations[saved] ? saved : 'en';
  });

  const t = translations[language];

  const setLanguage = (lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
      localStorage.setItem('faida-language', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
